import type { IStock } from "@/modules/stock/common/types";
import { Stocks } from "@/modules/stock/components";
import { PageHeader } from "@/shared/components";
import { Heading } from "@ab.uitools/ui-library/components/Heading";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const StocksPage = () => {
  const { t } = useTranslation();

  const [selectedStock, setSelectedStock] = useState<IStock | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <>
      <div className="full-width page-container">
        <PageHeader/>
        <div className="full-width flexbox justify-content--center h-fit-content page-body">
          <div className="widget-wrapper">
            <div className="full-width mb-20">
              <Heading className="content-title" size="xsmall" weight="bolder">
                {t("stocks.title")}
              </Heading>
            </div>
            <Stocks
              setIsOpen={setIsOpen}
              isDetailOpen={isOpen}
              selectedStock={selectedStock}
              setSelectedStock={setSelectedStock}
            />
          </div>
        </div>
      </div>
    </>
  );
};
